export const Loading = ({ hideText = false, style=null, text=null, loadingIconType = "spinner" }) => {
  return (
    <div className="flex justify-center items-center h-full !mt-0 pt-0" style={style}>

      {loadingIconType === "spinner" && (
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-kinetic-pink"></div>
      )}

      {loadingIconType === "3-circles" && (
        <img
          src="/mail-preview/global/spinner.gif"
          alt="Loading"
          className="w-8 h-8"
        />
      )}

      {!hideText && (
        <span className="ml-2 text-slate-500" style={{ color: style?.color }}>
          {text || "Loading..."}
        </span>
      )}
    </div>
  );
};
